import React from "react";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import HoverLines from "./HoverLines";

interface Props {
  props: any;
}

const CustomDot = ({ props: dotProps }: Props): JSX.Element => {
  const {
    color: { $chartSegmentOne, $chartLineTertiary, $backgroundSubtle },
  } = useTheme();

  if (!dotProps.cx || !dotProps.cy) {
    return <></>;
  }

  return (
    <>
      <HoverLines
        x={dotProps.cx}
        y={dotProps.cy}
        graphWidth={dotProps.graphWidth}
        graphHeight={dotProps.graphHeight}
        color={$chartLineTertiary}
      />

      <circle
        cx={dotProps.cx}
        cy={dotProps.cy}
        r={13}
        fill={$chartSegmentOne}
        fillOpacity={0.1}
        stroke={$chartSegmentOne}
        strokeOpacity={0.1}
        strokeWidth={1}
      />

      <circle
        cx={dotProps.cx}
        cy={dotProps.cy}
        r={8}
        fill={$backgroundSubtle}
        fillOpacity={1}
        stroke={$chartSegmentOne}
        strokeWidth={1.4}
      />

      <circle
        cx={dotProps.cx}
        cy={dotProps.cy}
        r={2.5}
        fill={$chartSegmentOne}
      />
    </>
  );
};

export default CustomDot;
